import { Method } from 'axios'

type Endpoint = string | ((isLos: boolean, isV2?: boolean) => string)

const API: Record<string, { endpoint: Endpoint; method: Method }> = {
  applicationDetails: {
    endpoint: (isLOS: boolean) =>
      isLOS
        ? '/los/internal/lending/application-details'
        : '/cc/integration/application-details',
    method: 'GET',
  },
  stateManage: {
    endpoint: (isLOS: boolean, isV2?: boolean) =>
      isLOS
        ? '/los/internal/lending/state'
        : `/cc/integration/${isV2 ? 'v2/' : ''}status-update`,
    method: 'POST',
  },
  resendOtp: {
    endpoint: '/cc/integration/resend-otp',
    method: 'GET',
  },
  autoComplete: {
    endpoint: (isLOS: boolean, isV2?: boolean) =>
      isLOS
        ? '/los/internal/lending/autocomplete'
        : `/cc/integration/${isV2 ? 'v2/' : ''}autocomplete`,
    method: 'GET',
  },
  documentUploadURL: {
    endpoint: '/los/internal/lending/upload/get',
    method: 'GET',
  },
  calculateEMI: {
    endpoint: '/los/internal/lending/hdfc/261/emi-calculator',
    method: 'POST',
  },
  uploadLoanDocument: {
    endpoint: '/public/bank/save/file',
    method: 'POST',
  },
} as const

export default API
